import FaceAuth from "@/components/_module/faceAuth/FaceAuth";

export default function FaceSignInPage() {
	return <FaceAuth />;
}
